import React, { useState } from "react";
import { useAnimalService } from "src/services/animalService";
import {
  AppBar,
  Box,
  Container,
  Typography,
  Toolbar,
  CircularProgress,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { useGetAnimalsQuery } from "src/services/api";
import { initialFormState, AnimalForm } from "../common/animalForm/animalForm";
import AnimalCard from "../common/animalForm/AnimalCard";
import AnimalFormDialog from "../common/AnimalFormDialog";
import { FaHorse, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AdminAnimalCard from "../common/animalForm/AdminAnimalCard";

const AdminPage: React.FC = () => {
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<AnimalForm>(initialFormState);
  const [files, setFiles] = useState<FileList | null>(null);

  const [authorized, setAuthorized] = useState(false);
  const { addAnimal, removeAnimal, isCreating, isDeleting } =
    useAnimalService();
  const { data: animals, isLoading, error } = useGetAnimalsQuery();

  const handlePasswordSubmit = () => {
    setAuthorized(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData(initialFormState);
  };

  const handleSubmit = async () => {
    try {
      await addAnimal(formData, files);
      handleClose();
    } catch (err) {
      console.error("Failed to create animal:", err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "age" ? Number(value) : value,
    }));
  };

  const handleChangeSelect = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      specie: value,
    }));
  };

  const onFileChange = (selectedFiles: FileList | null) => {
    setFiles(selectedFiles);
  };
  if (!authorized) {
    return (
      <Container>
        <Typography variant="h6" gutterBottom>
          Admin Access
        </Typography>
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handlePasswordSubmit}
        >
          Submit
        </Button>
      </Container>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Box
            sx={{ cursor: "pointer" }}
            display="flex"
            onClick={() => navigate("/")}
          >
            <FaHorse size={30} />
            <Box sx={{ width: 8 }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Rancho Recinos
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4 }}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center">
            Error loading animals. Please try again later.
          </Typography>
        ) : (
          <Grid container spacing={3}>
            <Grid size={12} display="flex" justifyContent="center">
              <Button
                onClick={() => setOpen(true)}
                variant="contained"
                startIcon={<FaPlus size={16} />}
              >
                Agregar animal
              </Button>
            </Grid>

            {animals?.map((animal) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={animal.id}>
                <AdminAnimalCard animal={animal} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      <AnimalFormDialog
        open={open}
        onClose={handleClose}
        formData={formData}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onFileChange={onFileChange}
        onSelectChange={handleChangeSelect}
      />
    </Box>
  );
};

export default AdminPage;
